import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';
import { Button } from './ui/button';
import { getApiBase } from '../utils/apiBase';

const API_URL = getApiBase() + '/api';

const WhatsNewModal = () => {
  const { user } = useAuth();
  const [entries, setEntries] = useState([]);
  const [open, setOpen] = useState(false);
  const [latestVersion, setLatestVersion] = useState(0);

  useEffect(() => {
    let cancelled = false;
    if (!user || user.onboarding_completed === false) return;
    const since = user.last_seen_changelog_version || 0;
    axios
      .get(`${API_URL}/changelog?since_version=${since}`, { withCredentials: true })
      .then((r) => {
        if (cancelled) return;
        const items = r.data?.items || [];
        if (items.length === 0) return;
        setEntries(items);
        setLatestVersion(items[0]?.version || 0);
        setOpen(true);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, [user]);

  if (!open) return null;

  const close = async () => {
    setOpen(false);
    try {
      await axios.post(
        `${API_URL}/me/changelog/${latestVersion}/seen`,
        {},
        { withCredentials: true },
      );
    } catch (_) {
      // sessiz
    }
  };

  return (
    <div className="fixed inset-0 z-[130] bg-black/85 backdrop-blur-sm flex items-end sm:items-center justify-center px-3 py-4">
      <div className="w-full max-w-md glass-effect rounded-2xl p-6 border border-white/10 shadow-xl">
        <h2
          className="text-lg font-bold text-white mb-1"
          style={{ fontFamily: 'Cinzel, serif' }}
        >
          Yenilikler
        </h2>
        <p className="text-[11px] text-zinc-500 mb-4">Son sürümlerde neler değişti?</p>
        <div className="space-y-4 max-h-80 overflow-y-auto pr-1">
          {entries.map((e) => (
            <div key={e.version} className="border-l-2 border-violet-500/40 pl-3">
              <div className="text-xs text-violet-300 font-semibold">
                v{e.version} {e.title ? `· ${e.title}` : ''}
              </div>
              <p className="text-xs text-zinc-300 leading-snug mt-1 whitespace-pre-line">
                {e.body || ''}
              </p>
            </div>
          ))}
        </div>
        <Button
          onClick={close}
          className="w-full mt-5 btn-primary"
          data-testid="whats-new-close"
        >
          Tamam
        </Button>
      </div>
    </div>
  );
};

export default WhatsNewModal;
